import React                      from 'react';
import { DataTable }              from '@components/index';
import { TDataTableRow }          from '@typings/components';
import { ICreditUnion }           from '@typings/accountManagement';
import { AccountPageWrapper }     from '@modules/accountManagement/components/AccountPageWrapper';
import { AUCTIONS_TABLE_HEADERS } from '../utils/tableHeaders';

interface IProps {
  push                : (path: string) => void;
  tableRows           : TDataTableRow[];
  accountData         : ICreditUnion;
  fetchAuctionsStatus : boolean;
}

export const AccountAuctionsPage: React.FC<IProps> = ({
  push,
  tableRows,
  accountData,
  fetchAuctionsStatus,
}) => (
  <AccountPageWrapper
    push   = {push}
    cuInfo = {accountData}
  >
    <DataTable
      headers   = {AUCTIONS_TABLE_HEADERS}
      rows      = {tableRows}
      loading   = {fetchAuctionsStatus}
      maxwidth  = "1680px"
      rowheight = "60px"
      collapsable
      collapsed
      aligntop
    />
  </AccountPageWrapper>
);
